import React, { useState } from "react";
import { Row, Col, Divider, Button } from "antd";
import {
  BsFileEarmarkWord,
  BsCalendarMinus,
  AiOutlineClockCircle,
  AiFillFilePdf,
} from "react-icons/all";
import moment from "moment";
import CustomModal from "../../components/modals/customModal";
import Delete_order from "../../assets/images/delete_order.png";
import { useSelector } from "react-redux";

const FileView = ({ item, deleteDocReq, orderId, isTesting }) => {

  const userData = useSelector((state) => state?.AuthReducer?.user[0]?.user)
  console.log("my user ho", userData);
  const [isOpenModal, setOpenModal] = useState(false);
  const splitFile = item?.attachment_file_name?.split(".");
  // console.log("splitFile", splitFile);
  const fileFormat = splitFile[splitFile.length - 1];
  return (
    <>
      <Col
        span={24}
        style={{
          padding: "20px 0px",
          borderBottom: "5px solid #efefef",
        }}
      >
        <Row>
          <Col span={2}>
            {fileFormat == "pdf" ? (
              <AiFillFilePdf size="30" color="red" />
            ) : (
              <BsFileEarmarkWord size={"30"} color="blue" />
            )}
          </Col>
          <Col span={20}>
            <h2>{item?.attachment_file_name}</h2>
          </Col>
        </Row>
        <Row justify="space-between" style={{ marginTop: "10px" }}>
          <Col span={2}></Col>
          <Col span={1}>
            <img
              src={item?.uploaded_by_user_image?.original}
              height="30"
              width={"30"}
              style={{ borderRadius: "50px" }}
            />
          </Col>
          <Col span={8}>
            <Row>
              <Col
                span={24}
                style={{
                  fontSize: "14px",
                  position: "relative",
                  top: "-5px",
                  left: "5px",
                  color: "#b2b2b2",
                }}
              >
                <span>Uploaded by: {item?.uploader_user_id == userData.id ? userData.first_name + " " + userData.last_name : item.uploaded_by}</span>
              </Col>
              <Col span={24} style={{ left: "5px" }}>
                <span
                  style={{
                    borderRadius: "5px",
                    padding: "3px",
                    backgroundColor: "#b2b2b2",
                  }}
                  className={"grey order-status-label"}
                >
                  {item?.uploaded_by_user_type}
                </span>{" "}
              </Col>
            </Row>
          </Col>
          <Col span={5}>
            <Row>
              <Col span={5}>
                <BsCalendarMinus size={"20"} />
              </Col>
              <Col span={19}>
                <p> {moment(item?.created_at).format("LL")}</p>
              </Col>
            </Row>
          </Col>
          <Col span={4}>
            <Row>
              <Col span={6}>
                <AiOutlineClockCircle size={"20"} />
              </Col>
              <Col span={18}>
                <p> {moment(item?.created_at).utc().format("LT")}</p>
              </Col>
            </Row>
          </Col>
          <Col span={4}>
            <Row justify="space-between">
              <Col
                span={13}
                className="st-primary pointer-cursor"
                onClick={() => (window.location.href = item?.attachment)}
              >
                Download
              </Col>
              {console.log("upload===>", item?.uploaded_by_user_type)}
              {item?.uploaded_by_user_type == "LOGISTICS PARTNER" && (
                <Col span={10} onClick={() => setOpenModal(true)}>
                  <p className="danger-color pointer-cursor">Delete</p>
                </Col>
              )}
            </Row>
          </Col>
        </Row>
      </Col>
      <CustomModal
        visible={isOpenModal}
        onCancelModal={() => setOpenModal(false)}
        footer={[
          <Row justify="center" style={{ margin: "20px" }}>
            <Col
              className="d-flex justify-content-center"
              style={{ width: "100%" }}
            >
              <Button
                style={{
                  backgroundColor: "#ff9800",
                  color: "#fff",
                  width: "30%",
                  border: "none",
                }}
                onClick={() =>
                  deleteDocReq(orderId, item.id, {
                    params: isTesting ? "test_documents" : "documents",
                  })
                }
              >
                YES
              </Button>
              <Button
                style={{
                  backgroundColor: "#26a69a ",
                  color: "#fff",
                  width: "30%",
                  border: "none",
                }}
                onClick={() => setOpenModal(false)}
              >
                NO
              </Button>
            </Col>
          </Row>,
        ]}
      >
        <Row justify="center">
          <Col className="d-flex justify-content-center" span={24}>
            <img src={Delete_order} />
          </Col>
          <Col span={12} style={{ textAlign: "center" }}>
            <span>{"Are you sure you want to delete this file?"}</span>
          </Col>
        </Row>
      </CustomModal>
    </>
  );
};
export default FileView;
